import { action } from '@ember/object';
import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class GoalsTeamRoute extends Route {
	@service('store') declare storeService: Service.Store;
	@service('model-manager/metrics') declare mmMetricsService: Service.ModelManager.Metrics;
	@service('model-manager/teams') declare mmTeamsService: Service.ModelManager.Teams;
	@service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;

	override beforeModel() {
		document.body.id = 'page-goals-team';
	}

	@action
	override willTransition(_transition: PublicTransition) {
		const goalRecords = this.mmGoalsService.allRecords;
		goalRecords.forEach((goal) => {
			goal.newBadge = false;
		});
	}
}
